export default __webpack_public_path__ + "static/media/LobbyLeftBanner.1084cd00.svg";